export class ErrorMessageConstants {

    static readonly ERROR_CATEGORY = [
        {
            "AUTH_RESP_CODE": "003",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "03",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "012",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "15",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "19",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "42",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "042",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "043",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "44",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "044",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "47",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "52",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "53",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "057",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "59",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "062",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "62",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "63",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "067",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "74",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "092",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "093",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "200",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "M03",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "M15",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "M19",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "M42",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "M44",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "M47",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "M52",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "M53",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "M59",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "M62",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "M63",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "M74",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "V03",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "V15",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "V19",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "V42",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "V44",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "V47",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "V52",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "V53",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "V59",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "V62",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "V63",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "V74",
            "CATEGORY": "Category1"
        },
        {
            "AUTH_RESP_CODE": "10",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "014",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "20",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "25",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "35",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "36",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "37",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "46",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "48",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "051",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "54",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "061",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "61",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "64",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "065",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "72",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "075",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "75",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "82",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "091",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "92",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "096",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "98",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "900",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M10",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M20",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M25",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M35",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M37",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M46",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M48",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M54",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M61",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M64",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M72",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M75",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M82",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "M92",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V10",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V20",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V25",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V35",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V36",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V37",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V46",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V48",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V54",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V61",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V64",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V72",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V75",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V82",
            "CATEGORY": "Category2"
        },
        {
            "AUTH_RESP_CODE": "V92",
            "CATEGORY": "Category2"
        }
    ];
    static readonly ERROR_MESSAGES_CREDITCARD = [
        {
            "paymentType": "CC",
            "errorType": "DECLINED",
            "errorMessage": "Your card issuer declined the transaction. Try again using a different payment method."
        },
        {
            "paymentType": "CC",
            "errorType": "ERROR",
            "errorMessage": "Your card issuer is unable to approve your transaction at this time. Try again using a different payment method."
        },
        {
            "paymentType": "CC",
            "errorType": "REJECT",
            "errorMessage": "Your card issuer is unable to approve your transaction at this time. Try again using a different payment method."
        },
        {
            "paymentType": "CC",
            "errorType": "Category1",
            "errorMessage": "The account number you entered was declined by the card issuer and cannot be resubmitted. Try again using a different payment method."
        },
        {
            "paymentType": "CC",
            "errorType": "Category2",
            "errorMessage": "Your card issuer is unable to approve your transaction at this time. Try again using a different payment method."
        },
        {
            "paymentType": "CC",
            "errorType": "3DS",
            "errorMessage": "Your card issuer was unable to authenticate you with the information supplied. Try again using a different payment method."
        },
        {
            "paymentType": "CC",
            "errorType": "FRAUD",
            "errorMessage": "Your transaction failed fraud screening. Try again using a different payment method."
        }
    ];
    static readonly ERROR_MESSAGES_TELECHECK = [
        {
            "paymentType": "TELECHECK",
            "errorType": "DATA_ENTRY_ERROR",
            "errorMessage": "We are unable to verify your account or identity information. Please review the information you entered to ensure that all information is correct, or try using a different payment method."
        },
        {
            "paymentType": "TELECHECK",
            "errorType": "RISK_DECLINE",
            "errorMessage": "We are unable to electronically process this transaction. Please use a different form of payment at this time."
        },
        {
            "paymentType": "TELECHECK",
            "errorType": "NEGATIVE_DECLINE",
            "errorMessage": "We are unable to electronically process this transaction. Please use a different form of payment at this time."
        }
    ];
    static readonly ERROR_MESSAGES_PAYPAL = [
        {
            "paymentType": "PAYPAL",
            "errorType": "ALL",
            "errorMessage": "Your PayPal transaction was declined. Try again using a different payment method"
        }
    ];

    static readonly ERROR_DEFAULT_MESSAGE = [
        {
            "paymentType": "DEFAULT",
            "errorType": "DEFAULT",
            "errorMessage": "Unable to process your transaction at this time. Please try a different payment method, or try again later."
        }
    ];
}